import type { Highlight } from "@/types/evidences";
import type { AnswerSource } from "./chat-ui.types";

export interface ApiEvidence {
  fse_id: string;
  document_id: string;
  highlights: string;
  citation_id: string;
  answer_start_offset: number;
  answer_end_offset: number;
  conversation_id: string;
}

export interface Message {
  id: string;
  type: "human" | "ai";
  content: string;
  created_at?: string | null;
  answer_source?: AnswerSource | null;
}

export interface ChatHistory {
  evidences: ApiEvidence[][];
  messages: Message[];
}

export const parseHighlights = (highlightsJson: string): Highlight[] => {
  try {
    return JSON.parse(highlightsJson) as Highlight[];
  } catch {
    return [];
  }
};
